import { Icon, ICONS, PLATFORM_THEME_COLORS, Popover } from '@thinknet-gmbh/platform-common-ui';

import { PLATFORM_PERMISSIONS } from '@thinknet-gmbh/platform-common';
import { PROCESS_TASKS_MODALS } from 'src/pages/settings/components/process-templates/process-templates.constants';

import { useUserCanManageDocument } from 'src/hooks/user-can-manage-document.hook';

import { IProcessTask } from 'src/pages/tasks-manager/task-manager.interfaces';

const ProcessTasksTableRowActions = ({ record, handleModals, t }: {
  record: IProcessTask
  handleModals: (modal: string, record: IProcessTask) => void,
  t: Function
}) => {

  const { canDelete, canDeleteAll } = useUserCanManageDocument({
    platformPermission: PLATFORM_PERMISSIONS.taskManagement,
    createdBy: record.createdBy,
  });

  const isCanDelete = canDeleteAll || canDelete;

  return (
    <Popover
      elements={[
        {
          label: t('common:buttons.edit'),
          icon: ICONS.editAlt,
          key: ICONS.editAlt,
          handler: () => {
            handleModals(PROCESS_TASKS_MODALS.edit, record);
          },
        },
        {
          label: t('common:buttons.delete'),
          icon: ICONS.trash,
          color: isCanDelete
            ? PLATFORM_THEME_COLORS.tone.red
            : PLATFORM_THEME_COLORS.grayVariations.murky,

          key: ICONS.trash,
          handler: () => {
            if (isCanDelete) {
              handleModals(PROCESS_TASKS_MODALS.delete, record);
            }
          },
        },
      ]}
    >
      <Icon
        icon={ICONS.dotsVerticalRounded}
        size={22}
        color={PLATFORM_THEME_COLORS.primary.grey}
        rightMargin={false}
      />
    </Popover>
  );
};

export default ProcessTasksTableRowActions;
